import * as signalR from "@microsoft/signalr";
import { OnInfotechEventObject } from "@/types/hubConnectionInterface";
import { projObject } from "@/types/projectInterface";

let hubConnection;

function startConnection(contactPersonId) {
  return new Promise((resolve) => {
    if (!hubConnection) {
      let hubUrl = "#{MT.HubAddress}";
      hubUrl = hubUrl.indexOf("#") > -1 ? "http://localhost:4496" : hubUrl;

      hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(hubUrl + "/bt", {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .withAutomaticReconnect()
        .build();

      hubConnection.start().then(function () {
        hubConnection.invoke("ConnectHub", contactPersonId);
        resolve(hubConnection);
      });
    } else {
      resolve(hubConnection);
    }
  });
}

function onInfotechEvent(vm) {
  if (hubConnection) {
    hubConnection.on(
      "OnInfotechEvent",
      (projects: Array<projObject>, direction: string) => {
        const data = {} as OnInfotechEventObject;
        data.projects = projects;

        if (direction === "in") {
          data.isCheckedIn = true;
        } else if (direction === "out") {
          data.isCheckedIn = false;
        }

        vm.$emit("OnInfotechEvent", data);
      }
    );
  }
}

export default { startConnection, onInfotechEvent };
